import { render, staticRenderFns } from "./Borradores.vue?vue&type=template&id=97a87afc"
import script from "./Borradores.vue?vue&type=script&lang=js"
export * from "./Borradores.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports